import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const TilehoanthanhReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TilehoanthanhReport
